
import { prettifyDate } from "@/utils/dates";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DateBlock extends Vue {
  @Prop({ type: String, default: "" }) readonly date!: string;

  get formattedDate() {
    return prettifyDate(this.date);
  }
}
